import { KreateUTxO } from "../../business-types";
import { ParseError, SafeParseReturnType } from "../common";

export function parseKreateUtxoArtwork(utxo: KreateUTxO) {
  ParseError.assert(utxo.datum.type === "artwork", "incorrect type");
  return {
    datumArtwork: utxo.datum.value,
    // feel free to add more data here
  };
}

export function safeParseKreateUtxoArtwork(
  utxo: KreateUTxO
): SafeParseReturnType<ReturnType<typeof parseKreateUtxoArtwork>> {
  try {
    const result = parseKreateUtxoArtwork(utxo);
    return { success: true, result };
  } catch (error) {
    return { success: false, error };
  }
}
